module.exports = __webpack_public_path__ + "1685c3414cfbc86ccdea74d25c0deca3.png";


//////////////////
// WEBPACK FOOTER
// ../images/content_download_survey/twitter_gray.png
// module id = 1096
// module chunks = 69